import {
  Row,
  Col,
  DatePicker,
  Button,
  message,
  Typography,
  Modal,
  Badge,
  Card,
  List,
  Tooltip,
  Radio,
} from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  RedoOutlined,
} from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import APICaller from "../../utils/APICaller";
import { useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { decryptData } from "../../components/Constants";
import { SlideshowLightbox } from "lightbox.js-react";
import CustomLoader from "../../components/CustomLoader";
import dayjs from "dayjs";

export default function ExpenseListingDetail() {
  const { RangePicker } = DatePicker;
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.pathname?.split("/")?.[2];

  let storeRole = useSelector((state) => state.auth.role);

  const decryptedEmpID = useSelector((state) => state.auth.empID);

  let storeToken = useSelector((state) => state.auth.accessToken);

  let storeLIUId = useSelector((state) => state.auth.lIUId);

  let storeUserInfo = useSelector((state) => state.auth.userInfo);
  storeUserInfo = decryptData(storeUserInfo);

  const storeAcknowledgement = storeUserInfo?.user?.canSendExpenseRequest;

  // Initialize storeList with a default value
  const [mainSelectionForModeOfPayment, setMainSelectionForModeOfPayment] =
    useState(null);
  const [creditCardOption, setCreditCardOption] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [users, setUsers] = useState([]);

  const [departments, setDepartments] = useState([]);
  const [projectCodes, setProjectCodes] = useState([]);
  const [expenseCodes, setExpenseCodes] = useState([]);
  const [allCurrencies, setAllCurrencies] = useState([]);
  const [expenseDetail, setExpenseDetail] = useState();
  const [natureOfExpenseSelectedValue, setNatureOfExpenseSelectedValue] =
    useState();
  const [errorMsg, setErrorMsg] = useState({ expensesDetails: [] }),
    [errors, setErrors] = useState([]);

  const [paymentStatus, setPaymentStatus] = useState(false);
  const [paymentPaidOn, setPaymentPaidOn] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [mediaItem, setMediaItem] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const storeAccessTokenExpiresOn = useSelector(
    (state) => state.auth.accessTokenExpiresOn,
  );

  const [natureOfExpense, setNatureOfExpense] = useState([
    { label: "Already Paid - Filling", value: "Already Paid - filling" },
    { label: "Reimbursement", value: "Reimbursement" },
    { label: "Travel Settlement", value: "Travel Settlement" },
    { label: "Vendor Bill", value: "Vendor Bill" },
  ]);

  const [rows, setRows] = useState([
    {
      date: "",
      description: "",
      departmentID: "",
      expenseCodeID: "",
      currencyID: "",
      cost: "",
      mediaInfo: [],
    },
  ]);

  const handleChange = (index, field, value) => {
    // Create a copy of the mediaInfo array for the respective detail

    let updatedRows = [...rows];

    if (!updatedRows[index]) {
      message.error(`Row at index ${index} does not exist!`);
      return; // Exit early if the row at the given index does not exist
    }
    if (field === "departmentID" || field === "expenseCodeID") {
      updatedRows[index][field] = value?.value;
    } else {
      updatedRows[index][field] = value;
    }
    setRows(updatedRows);

    // Update the mediaInfo in the specific detail
    const updatedDetails = (expenseDetail?.expensesDetails || []).map(
      (item, idx) => {
        if (idx === index) {
          return {
            ...item,
            [field]: updatedRows[index][field],
          };
        }
        return item;
      },
    );
    // Update the state or parent component's state with the updated expenseDetail
    setExpenseDetail((prevState) => ({
      ...prevState,
      expensesDetails: updatedDetails,
    }));
  };

  //GetCurrencies
  const getAllCurrencies = () => {
    const endpoint = "/currency/findAll";
    const method = "POST";
    const payload = {
      fetchWithoutPagination: "yes",
    };

    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn,
    )
      .then((response) => {
        const temp = [];
        response &&
          response?.response?.map((currency, index) => {
            temp.push({
              label: currency?.code,
              value: currency?._id,
            });
          });
        setAllCurrencies(temp);
      })
      .catch((error) => {});
  };

  // GetProjectCodes
  const getProjectCodes = () => {
    const endpoint = "/project-code/findAll";
    const method = "POST";
    const payload = {
      fetchWithoutPagination: "yes",
    };

    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn,
    )
      .then((response) => {
        //const temp = [{ label: "N/A", value: null }];
        const temp = [];
        response?.response?.map((projectCode, index) => {
          temp.push({
            label: projectCode?.code + " - " + projectCode?.companyName,
            value: projectCode?._id,
          });
        });

        setProjectCodes(temp);
      })
      .catch((error) => {});
  };

  // GetDepartments
  const getDepartments = () => {
    const endpoint = "/departments/findAll";
    const method = "POST";
    const payload = {
      fetchWithoutPagination: "yes",
    };
    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn,
    )
      .then((response) => {
        const temp = [];
        response?.response?.map((department, index) => {
          temp.push({ label: department?.name, value: department?._id });
        });
        setDepartments(temp);
      })
      .catch((error) => {});
  };

  // GetExpenseCodes
  const getExpenseCodes = () => {
    const endpoint = "/expense-code/findAll";
    const method = "POST";
    const payload = {
      fetchWithoutPagination: "yes",
    };
    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn,
    )
      .then((response) => {
        const temp = [];
        response?.response?.map((expenseCode, index) => {
          temp.push({
            label: expenseCode?.costCode + " - " + expenseCode?.name,
            value: expenseCode?._id,
          });
        });
        setExpenseCodes(temp);
      })
      .catch((error) => {});
  };

  // GetUsers
  const getUsers = async () => {
    try {
      const endpoint = "/users/findAll";
      const method = "POST";
      const payload = {
        fetchWithoutPagination: "yes",
      };

      const response = await APICaller(
        storeRole,
        storeToken,
        endpoint,
        method,
        payload,
        storeAccessTokenExpiresOn,
      );
      const approvers =
        response &&
        response?.response.filter((item) => item.level2Approver === true);
      setUsers(approvers);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  //Expense's details
  const getExpenseDetail = async () => {
    try {
      const endpoint = `/list-of-expense/${id}`;
      const method = "GET";
      const payload = {};
      const response = await APICaller(
        storeRole,
        storeToken,
        endpoint,
        method,
        payload,
        storeAccessTokenExpiresOn,
      );
      setExpenseDetail(response);

      setNatureOfExpenseSelectedValue(response?.natureOfExpense);

      // Transform the response.expensesDetails to match the rows structure
      if (response?.expensesDetails) {
        const rowsData = response.expensesDetails.map((detail) => ({
          date: detail.date || "", // Map the appropriate fields
          description: detail.description || "",
          departmentID: detail.departmentID || "",
          expenseCodeID: detail.expenseCodeID || null,
          currencyID: detail.currencyID || "",
          cost: detail.cost || "",
          mediaInfo: detail.mediaInfo || [], // If mediaInfo exists
        }));

        // Set the transformed data into the rows state
        setRows(rowsData);
      }
    } catch (error) {
      console.error("Error fetching expense details:", error);
    }
  };

  useEffect(() => {
    getExpenseDetail();
  }, [users]);
  useEffect(() => {
    getUsers();
    getAllCurrencies();
    getProjectCodes();
    getExpenseCodes();
    getDepartments();
  }, []);

  // Disable dates after the current date
  const disableFutureDates = (current) => {
    const startDate = moment(current).subtract(1, "month").startOf("day");

    // Calculate the end date for the next financial year
    const currentYear = moment().year();
    const nextFinancialYearEnd = moment()
      .month(2)
      .date(31)
      .year(
        currentYear + (moment().isAfter(moment().month(2).date(31)) ? 1 : 0),
      )
      .endOf("day");

    // Disable dates outside the range two months ago from today to next financial year's 31st March
    return (
      current &&
      (current.isBefore(startDate) || current.isAfter(moment().endOf("day")))
    );
  };

  const disableFutureDatesForPaymentPaidOn = (current) => {
    const startDate = moment(current).startOf("day");

    // Calculate the end date for the next financial year
    const currentYear = moment().year();
    const nextFinancialYearEnd = moment()
      .month(2)
      .date(31)
      .year(
        currentYear + (moment().isAfter(moment().month(2).date(31)) ? 1 : 0),
      )
      .endOf("day");

    // Disable dates outside the range two months ago from today to next financial year's 31st March
    return (
      current &&
      (current.isBefore(startDate) || current.isAfter(nextFinancialYearEnd))
    );
  };

  const images =
    expenseDetail?.expensesDetails?.flatMap((detail) =>
      detail.mediaInfo
        ?.filter(
          (file) =>
            file?.savedFileType === "jpeg" ||
            file?.savedFileType === "jpg" ||
            file?.savedFileType === "png",
        )
        ?.map(
          (file) => process.env.REACT_APP_BACKEND + "/" + file?.savedFilepath,
        ),
    ) || [];

  const handleImageClick = (filePath) => {
    const index = images.findIndex((img) => img === filePath);
    if (index !== -1) {
      setPhotoIndex(index);
      setIsOpen(true);
    }
  };
  const parseToFloat = (value) => {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };
  const subTotal = rows.reduce(
    (total, row) => total + parseToFloat(row.cost),
    0,
  );

  const totalReimbursement =
    !rows?.[0]?.cost && expenseDetail?.totalReimbursement
      ? expenseDetail?.totalReimbursement.toFixed(2)
      : subTotal.toFixed(2);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = (e) => {
    e.preventDefault();
    if (
      storeRole === process.env.REACT_APP_ADROLE &&
      expenseDetail?.status ===
        process.env.REACT_APP_APPROVED_STATUS.toUpperCase() &&
      paymentStatus === false
    ) {
      //!approversApproved
      message.error("Payment Status is Mandatory");
      setErrorMsg({
        ...errorMsg,
        paymentStatus: "Payment Status is Mandatory",
      });
    } else if (
      storeRole === process.env.REACT_APP_ADROLE &&
      paymentStatus === true &&
      paymentPaidOn === null &&
      mainSelectionForModeOfPayment === null
    ) {
      message.error(
        "Payment Paid On date and Mode of Payment both are Mandatory",
      );
      setErrorMsg({
        ...errorMsg,
        paymentPaidOn: "Payment Paid On date is Mandatory",
        modeOfPayment: "Mode of Payment is Mandatory",
      });
    } else if (
      storeRole === process.env.REACT_APP_ADROLE &&
      paymentStatus === true &&
      paymentPaidOn === null &&
      mainSelectionForModeOfPayment !== null
    ) {
      message.error("Payment Paid On date is Mandatory");
      setErrorMsg({
        ...errorMsg,
        paymentPaidOn: "Payment Paid On date is Mandatory",
      });
    } else if (
      storeRole === process.env.REACT_APP_ADROLE &&
      paymentStatus === true &&
      paymentPaidOn !== null &&
      mainSelectionForModeOfPayment === "Credit Card" &&
      creditCardOption === ""
    ) {
      message.error("Please select Credit Card option");
      setErrorMsg({
        ...errorMsg,
        modeOfPayment: "Please select Credit Card option",
      });
    } else if (
      storeRole === process.env.REACT_APP_ADROLE &&
      paymentStatus === true &&
      mainSelectionForModeOfPayment === null &&
      paymentPaidOn !== null
    ) {
      message.error("Mode of Payment is Mandatory");
      setErrorMsg({
        ...errorMsg,
        modeOfPayment: "Mode of Payment is Mandatory",
      });
    } else if (errors?.fileSizeExceed === "single") {
      message.error("File size exceeds 5 MB.");
    } else if (errors?.fileSizeExceed === "total") {
      message.error("The total size of all files must not exceed 10 MB.");
    } else if (errors?.fileCountExceed) {
      message.error(
        "You cannot only upload one attachment so upload accordingly.",
      );
    } else if (totalReimbursement.indexOf("-") !== -1) {
      message.error(
        totalReimbursement +
          " amount is with you. If you have any concern then please contact with Finance Department!!",
      );
    } else {
      setIsModalVisible(true);
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setShowLoader(true);
    setErrors({ fileSizeExceed: "", fileCountExceed: false });
    const endpoint = `/list-of-expense/${id}`;
    const method = "PUT";
    const payload = {
      role: storeRole,
      lIUId: storeLIUId,
      empName: expenseDetail?.empName,
      empID: parseInt(expenseDetail?.empID),
      departmentID: expenseDetail?.departmentID?._id,
      projectCodeID: expenseDetail.projectCodeID?._id,
      expensePeriodFromDate: expenseDetail?.expensePeriodFromDate,
      expensePeriodToDate: expenseDetail?.expensePeriodToDate,
      natureOfExpense: natureOfExpenseSelectedValue,
      businessPurpose: expenseDetail?.businessPurpose,
      expensesDetails: rows?.[0]?.cost ? rows : expenseDetail?.expensesDetails,
      paymentPaidOn: paymentPaidOn,
      modeOfPayment: finalModeOfPayment,
      totalReimbursement: totalReimbursement,
      ackMessage: expenseDetail?.ackMessage || null,
      historySource: "backend",
      historyAction:
        paymentPaidOn != null
          ? `Admin updated payment status: ${paymentPaidOn}`
          : expenseDetail?.status ===
              process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
            ? "sentback-resubmitted"
            : "update",
      historyUserID: storeLIUId,
      status: paymentPaidOn
        ? expenseDetail?.status
        : expenseDetail?.status ===
            process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
          ? process.env.REACT_APP_RESUBMITTED_STATUS.toUpperCase()
          : expenseDetail?.status,
    };

    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn,
    )
      .then((response) => {
        message.success(
          response && response?.paymentPaidOn !== null
            ? "Expense updated successfully."
            : "Expense resubmitted successfully.",
        );
        setExpenseDetail({ ...expenseDetail });
        setRows([
          {
            date: "",
            description: "",
            departmentID: "",
            expenseCodeID: "",
            currencyID: "",
            cost: "",
            mediaInfo: [],
          },
        ]);
        setShowLoader(false);
        navigate(`/${process.env.REACT_APP_DASHBOARD_EL_SEARCH_IN}`);
      })
      .catch((error) => {
        setShowLoader(false);
      });
  };

  const hasViewAccess =
    storeRole === process.env.REACT_APP_AROLE
      ? expenseDetail &&
        expenseDetail?.approvers.filter((expenseValue) => {
          return expenseValue?.userID == storeLIUId;
        })
      : "";
  const approversStatusCount = expenseDetail?.approvers.filter(
    (approver) =>
      approver.status === process.env.REACT_APP_APPROVED_STATUS.toUpperCase(),
  ).length;

  useEffect(() => {
    // Only check conditions once the data is available , itself || manager || admin after manager approver
    if (storeRole && expenseDetail) {
      if (decryptedEmpID !== expenseDetail?.empID) {
        if (
          hasViewAccess &&
          hasViewAccess.length === 0 &&
          storeUserInfo?.user?.canSendExpenseRequest !== false
        ) {
          setShouldRedirect(true);
        }
      }
      setIsLoading(false);
    }
  }, [storeRole, expenseDetail]);

  // if (isLoading) {
  //   return <CustomLoader showLoader={showLoader} />; // Show a loading state while checking conditions
  // }

  if (shouldRedirect) {
    return <Navigate to="/dashboard" />;
  }

  // Function to remove media
  const handleMediaRemove = (detail, index) => {
    // Show confirmation modal
    Modal.confirm({
      title: "Confirm Removal",
      content: "Are you sure you want to remove this media item?",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        // Create a copy of the mediaInfo array for the respective detail
        let updatedMediaInfo = [...detail.mediaInfo];
        // Remove the selected file from the array (e.g., removing the first item for simplicity)
        updatedMediaInfo.splice(0, 1); // You can adjust the index based on your logic

        // Check if mediaInfo is empty after removal and set it explicitly to an empty array
        if (updatedMediaInfo.length === 0) {
          updatedMediaInfo = []; // Set to empty array if no files are left
          //updateRowFiles(index, fileSources, updatedRows);
        }
        // Update the mediaInfo in the specific detail
        const updatedDetails = expenseDetail?.expensesDetails.map(
          (item, idx) => {
            if (idx === index) {
              return {
                ...item,
                mediaInfo: updatedMediaInfo,
              };
            }
            return item;
          },
        );

        // Update the state or parent component's state with the updated expenseDetail
        setExpenseDetail((prevState) => ({
          ...prevState,
          expensesDetails: updatedDetails,
        }));
        setRows((prevRows) =>
          prevRows.map((row, idx) => {
            if (idx === index) {
              return {
                ...row,
                mediaInfo: updatedMediaInfo, // Update mediaInfo for the specific row
              };
            }
            return row; // Keep other rows unchanged
          }),
        );
        setMediaItem((prevState) => ({
          ...prevState,
          ["item_" + index]: "removed",
        }));
      },
      onCancel: () => {
        // Optionally, handle cancellation logic here
        console.log("Removal cancelled");
      },
    });
  };

  const handleFileChange = (index, event) => {
    const files = event.target.files;
    if (files.length && files.length > 1) {
      setErrors({ fileCountExceed: true });
      message.error(
        `Only one file can be uploaded. Allowed file type: .jpg, .png, max size: 4MB.`,
      );
    } else {
      if (mediaItem?.["item_" + index] === undefined) {
        setMediaItem((prevState) => ({
          ...prevState,
          ["item_" + index]: "freshUpload",
        }));
      }

      setErrors({ fileCountExceed: false });

      let totalSize = 0;

      const maxSingleFileSize = 4 * 1024 * 1024; // 5 MB in bytes

      const updatedRows = [...rows];

      const arrayBufferToBase64 = (buffer) => {
        let binary = "";
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
      };

      const loadFile = (file) => {
        const reader = new FileReader();
        const fileType = file.type;
        totalSize += file.size;

        if (file.size > maxSingleFileSize) {
          setErrors({ fileSizeExceed: "single" });
          message.error(`File "${file.name}" exceeds 4 MB.\n`);
        } else {
          reader.onload = (e) => {
            const newFileData = {
              src: fileType.startsWith("image/")
                ? e.target.result
                : `data:${fileType};base64,${arrayBufferToBase64(
                    e.target.result,
                  )}`,
              name: file.name,
              type: fileType,
            };
            const fileSources = [newFileData];
            // Ensure the new file is set for the correct row
            if (fileSources.length <= 1) {
              updateRowFiles(index, fileSources, updatedRows);
            }

            // Update only the mediaInfo for the specific index
            const updatedDetails = expenseDetail?.expensesDetails.map(
              (item, idx) => {
                if (idx === index) {
                  const updatedMediaInfo = [...item.mediaInfo];

                  // Replace or add the new file, assuming only one file can be uploaded
                  if (updatedMediaInfo.length > 0) {
                    updatedMediaInfo[0] = newFileData; // Replace the first item
                  } else {
                    updatedMediaInfo.push(newFileData); // Add the new file
                  }

                  return {
                    ...item,
                    mediaInfo: updatedMediaInfo, // Update mediaInfo for the current index
                  };
                }
                return item; // Keep other items intact
              },
            );

            // Update the state with the updated mediaInfo array
            setExpenseDetail((prevState) => ({
              ...prevState,
              expensesDetails: updatedDetails,
            }));
          };

          if (fileType.startsWith("image/")) {
            reader.readAsDataURL(file); // For images
          } else {
            reader.readAsArrayBuffer(file); // For non-image files
          }
        }
      };

      Array.from(files).forEach(loadFile);
    }
  };

  const updateRowFiles = (index, fileSources, updatedRows) => {
    if (!updatedRows[index].mediaInfo) {
      updatedRows[index].mediaInfo = [];
    }
    updatedRows[index].mediaInfo = fileSources;
    setRows(updatedRows);
  };

  const getStatusBadge = (status, reason) => {
    switch (status) {
      case "APPROVED":
        return (
          <Badge
            status="success"
            text="Approved"
            icon={<CheckCircleOutlined />}
            className="approved-badge"
          />
        );
      case "PENDING":
        return (
          <Badge
            status="warning"
            text="Pending Approval: Request Sent"
            icon={<ClockCircleOutlined />}
            className="pending-badge"
          />
        );
      case "CANCELED":
        return (
          <Badge
            status="error"
            text={
              <span>
                <strong>Canceled</strong>: {reason}
              </span>
            }
            icon={<CloseCircleOutlined />}
            className="canceled-badge"
          />
        );
      case "SENTBACK":
        return (
          <Badge
            status="processing"
            text={
              <span>
                <strong>Sent Back</strong>: {reason}
              </span>
            }
            icon={<RedoOutlined />}
            className="sentBack-badge"
          />
        );
      default:
        return (
          <Badge
            status="default"
            text="Awaiting previous Approver's Approval"
            icon={<ExclamationCircleOutlined />}
          />
        );
    }
  };

  // Assign intermediate variables for conditions
  const isNoResponseStatus =
    expenseDetail?.status ===
      process.env.REACT_APP_NORESPONSE_STATUS.toUpperCase().replace(" ", "") &&
    expenseDetail?.isNoResponse;

  const isHistoryNoResponseStatus =
    expenseDetail?.history[
      expenseDetail?.history.length - 1
    ]?.status.toUpperCase() ===
    process.env.REACT_APP_NORESPONSE_STATUS.toUpperCase().replace(" ", "");

  const isStoreRoleAdmin = storeRole === process.env.REACT_APP_ADROLE;

  const isSentBackStatus =
    expenseDetail?.status ===
    process.env.REACT_APP_SENTBACK_STATUS.toUpperCase();

  const isCurrentUser = expenseDetail?.empID === decryptedEmpID;

  // Now combine the conditions logically
  const shouldShowResubmitButton =
    (isNoResponseStatus && isHistoryNoResponseStatus && isStoreRoleAdmin) ||
    (isCurrentUser && isSentBackStatus);

  // Assigning intermediate variables for conditions
  const isPendingWithNoAcknowledgment =
    approversStatusCount === expenseDetail?.approvers.length &&
    expenseDetail?.status ===
      process.env.REACT_APP_PENDING_STATUS.toUpperCase() &&
    expenseDetail?.seekAcknowledgment?.[0]?.sentAt === null;
  const isSentBack =
    expenseDetail?.history[expenseDetail?.history.length - 1].status ===
    process.env.REACT_APP_SENTBACK_STATUS.toUpperCase();
  const isApprovedWithNoPayment =
    expenseDetail?.status ===
      process.env.REACT_APP_APPROVED_STATUS.toUpperCase() &&
    expenseDetail?.paymentPaidOn === null;

  const isStoreRoleAdminWithPending =
    storeRole === process.env.REACT_APP_ADROLE && isApprovedWithNoPayment;

  const isStoreRoleARoleWithAcknowledgment =
    storeRole === process.env.REACT_APP_AROLE &&
    storeAcknowledgement === false &&
    expenseDetail?.seekAcknowledgment[0]?.sentAt !== null &&
    expenseDetail?.seekAcknowledgment[0]?.ackMessage === null;

  // Now use these variables in the condition
  const shouldShowUpdateButton =
    isStoreRoleAdminWithPending || isStoreRoleARoleWithAcknowledgment;

  const handleMainChange = (e) => {
    const value = e.target.value;
    if (value) {
      setMainSelectionForModeOfPayment(value);
    }

    if (value !== "Credit Card") {
      setCreditCardOption(""); // reset if switching away
    }
  };

  const handleCreditCardOptionChange = (e) => {
    setCreditCardOption(e.target.value);
  };

  const finalModeOfPayment =
    mainSelectionForModeOfPayment === "Credit Card"
      ? `Credit Card: ${creditCardOption}`
      : mainSelectionForModeOfPayment;

  return (
    <>
      <div className="container">
        <CustomLoader showLoader={showLoader} />
        <div className="card bgi-no-repeat card-stretch gutter-b border-2 rounded-lg p-0">
          <div className="border-2 card-header p-6">
            <h3 className="card-title m-0 p-0 border-2 font-weight-bolder text-dark font-size-lg">
              Expense Details
            </h3>
          </div>
          <div className="card-body p-3">
            <form
              layout="vertical"
              autoComplete="off"
              className="form-validation-start"
              onSubmit={onFinish}
            >
              <Row gutter={[24, 24]}>
                <Col sm={8}>
                  <label className="mb-3" name="empID">
                    Employee ID
                  </label>

                  <input
                    placeholder="Id"
                    className="form-control rounded-md"
                    defaultValue={expenseDetail?.empID}
                    disabled
                  />
                </Col>

                <Col sm={8}>
                  <label className="mb-3" name="empName">
                    Employee Name
                  </label>

                  <input
                    defaultValue={expenseDetail?.empName}
                    disabled
                    placeholder="Employee Name"
                    className="form-control rounded-md"
                  />
                </Col>

                <Col sm={8}>
                  <label className="mb-3" name="departmentID">
                    Department
                  </label>

                  <input
                    placeholder="Department"
                    className="form-control rounded-md"
                    disabled
                    defaultValue={`${expenseDetail?.departmentID?.name} - ${expenseDetail?.departmentID?.code}`}
                  />
                </Col>

                <Col sm={8}>
                  <label className="mb-3" htmlFor="expensePeriodFromDate">
                    <span className="mandatory-symbol">*</span>Expense Period:
                    (From - To)
                  </label>

                  <RangePicker
                    // disabledDate={disableFutureDates}
                    className="form-control rounded-md d-inline-flex"
                    format="DD-MM-YYYY"
                    value={[
                      expenseDetail?.expensePeriodFromDate
                        ? moment(expenseDetail?.expensePeriodFromDate)
                        : null,
                      expenseDetail?.expensePeriodToDate
                        ? moment(expenseDetail?.expensePeriodToDate)
                        : null,
                    ]}
                    disabled
                  />
                </Col>

                <Col sm={8}>
                  <label className="mb-3" name="projectCodeID">
                    <span className="mandatory-symbol">*</span>Project Code
                  </label>
                  <input
                    className="form-control rounded-md"
                    disabled
                    value={
                      expenseDetail?.projectCodeID?.code &&
                      expenseDetail?.projectCodeID?.companyName
                        ? expenseDetail?.projectCodeID?.code +
                          " - " +
                          expenseDetail?.projectCodeID?.companyName
                        : "N/A"
                    }
                  />
                </Col>
                {expenseDetail?.natureOfExpense && (
                  <Col
                    sm={8}
                    id={
                      expenseDetail?.empID === decryptedEmpID &&
                      expenseDetail?.status ===
                        process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                        ? ""
                        : "loe-disb"
                    }
                  >
                    <label className="mb-3" name="natureOfExpense">
                      <span className="mandatory-symbol">*</span>Nature of
                      Expense
                    </label>

                    <Select
                      isDisabled={
                        expenseDetail?.empID === decryptedEmpID &&
                        expenseDetail?.status ===
                          process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                          ? false
                          : true
                      }
                      className={
                        expenseDetail?.empID === decryptedEmpID &&
                        expenseDetail?.status ===
                          process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                          ? "rounded-md"
                          : "select-isDisabled rounded-md"
                      }
                      placeholder="Select nature of expense"
                      defaultValue={{
                        label: `${expenseDetail?.natureOfExpense}`,

                        value: expenseDetail?.natureOfExpense,
                      }}
                      onChange={(item) => {
                        setNatureOfExpenseSelectedValue(item.value);
                      }}
                      options={natureOfExpense}
                    />
                  </Col>
                )}
                <Col sm={8}>
                  <label className="mb-3" name="businessPurpose">
                    <span className="mandatory-symbol">*</span>Vendor Name
                  </label>

                  <textarea
                    className="form-control rounded-md"
                    disabled
                    value={expenseDetail?.businessPurpose || "N/A"}
                  ></textarea>
                </Col>
              </Row>
              <Row gutter={[24, 24]}>
                <Col xs={24}>
                  <div className="border-top my-10"></div>
                </Col>
              </Row>
              <Row gutter={[24, 24]}>
                <Col xs={24}>
                  <div className="border-top my-10"></div>
                </Col>
              </Row>
              {/*Repeater Area*/}
              <div className="repeter border border-light-dark mb-5 p-3 repeter rounded-sm">
                <Row gutter={[12, 12]} className="m-0">
                  <Col sm={3} className="repeat-label">
                    <label className="mb-0">
                      <span className="mandatory-symbol">*</span>Date
                    </label>
                  </Col>
                  <Col sm={3} className="repeat-label">
                    <label className="mb-0">
                      <span className="mandatory-symbol">*</span>Description
                    </label>
                  </Col>
                  <Col sm={3} className="repeat-label">
                    <label className="mb-0">
                      <span className="mandatory-symbol">*</span>Department
                    </label>
                  </Col>
                  <Col sm={4} className="repeat-label">
                    <label className="mb-0">
                      <span className="mandatory-symbol">*</span>Expense Code
                    </label>
                  </Col>
                  <Col sm={3} className="repeat-label">
                    <label className="mb-0">
                      <span className="mandatory-symbol">*</span>Currency
                    </label>
                  </Col>
                  <Col sm={3} className="repeat-label">
                    <label className="mb-0">
                      <span className="mandatory-symbol">*</span>Cost
                    </label>
                  </Col>
                  <Col sm={2} className="repeat-label">
                    <label className="mb-0">Upload</label>
                  </Col>
                </Row>

                {expenseDetail?.expensesDetails &&
                  expenseDetail?.expensesDetails.map((detail, index) => {
                    return (
                      <Row gutter={[12, 12]} className="mb-4" key={index}>
                        <Col sm={3}>
                          <DatePicker
                            format="DD-MM-YYYY"
                            // disabledDate={disableFutureDates}
                            disabled={
                              expenseDetail?.empID === decryptedEmpID &&
                              expenseDetail?.status ===
                                process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                                ? false
                                : true
                            }
                            className="form-control rounded-md"
                            defaultValue={[
                              detail?.date
                                ? dayjs(detail?.date, "YYYY-MM-DD")
                                : null,
                            ]}
                            allowClear={true}
                            onChange={(date) => {
                              const formattedDate = date.format("YYYY-MM-DD");
                              handleChange(index, "date", formattedDate);

                              const tempErrors = [...errorMsg.expensesDetails];

                              tempErrors[index] = {
                                ...tempErrors[index],

                                date: date ? "" : "Date is Mandatory",
                              };

                              setErrorMsg({
                                ...errorMsg,
                                expensesDetails: tempErrors,
                              });
                            }}
                          />

                          <small className="text-danger">
                            {errorMsg.expensesDetails[index]?.date}
                          </small>
                        </Col>

                        <Col
                          sm={3}
                          id={
                            expenseDetail?.empID === decryptedEmpID &&
                            expenseDetail?.status ===
                              process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                              ? ""
                              : "loe-disb"
                          }
                        >
                          <input
                            disabled={
                              expenseDetail?.empID === decryptedEmpID &&
                              expenseDetail?.status ===
                                process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                                ? false
                                : true
                            }
                            placeholder="Description"
                            className="form-control rounded-md text-capitalize"
                            defaultValue={detail?.description}
                            onChange={(e) => {
                              handleChange(
                                index,
                                "description",
                                e.target.value,
                              );

                              const tempErrors = [...errorMsg.expensesDetails];
                              tempErrors[index] = {
                                ...tempErrors[index],
                                description: e.target.value
                                  ? ""
                                  : "Description is mandatory",
                              };
                              setErrorMsg({
                                ...errorMsg,
                                expensesDetails: tempErrors,
                              });
                            }}
                          />

                          <small className="text-danger">
                            {errorMsg.expensesDetails[index]?.description}
                          </small>
                        </Col>

                        <Col
                          sm={3}
                          id={
                            expenseDetail?.empID === decryptedEmpID &&
                            expenseDetail?.status ===
                              process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                              ? ""
                              : "loe-disb"
                          }
                        >
                          {departments.length > 0 && (
                            <>
                              <Select
                                isDisabled={
                                  expenseDetail?.empID === decryptedEmpID &&
                                  expenseDetail?.status ===
                                    process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                                    ? false
                                    : true
                                }
                                className={
                                  expenseDetail?.empID === decryptedEmpID &&
                                  expenseDetail?.status ===
                                    process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                                    ? "rounded-md"
                                    : "select-isDisabled rounded-md"
                                }
                                placeholder="Select Department"
                                defaultValue={{
                                  label: `${detail?.departmentID?.name} - ${detail?.departmentID?.code}`,

                                  value: detail?.departmentID?._id,
                                }}
                                onChange={(value) => {
                                  handleChange(index, "departmentID", value);
                                  const tempErrors = [
                                    ...errorMsg.expensesDetails,
                                  ];
                                  tempErrors[index] = {
                                    ...tempErrors[index],
                                    departmentID: value?.value
                                      ? ""
                                      : "Department is Mandatory",
                                  };
                                  setErrorMsg({
                                    ...errorMsg,
                                    expensesDetails: tempErrors,
                                  });
                                }}
                                options={departments}
                              />

                              <small className="text-danger">
                                {errorMsg.expensesDetails[index]?.departmentID}
                              </small>
                            </>
                          )}
                        </Col>

                        <Col
                          sm={4}
                          id={
                            expenseDetail?.empID === decryptedEmpID &&
                            expenseDetail?.status ===
                              process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                              ? ""
                              : "loe-disb"
                          }
                        >
                          {expenseCodes.length > 0 && (
                            <div
                              title={
                                expenseCodes.find(
                                  (obj) =>
                                    obj.value === detail?.expenseCodeID?._id,
                                )?.label || "Select Expense Code"
                              }
                            >
                              <Select
                                isDisabled={
                                  expenseDetail?.empID === decryptedEmpID &&
                                  expenseDetail?.status ===
                                    process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                                    ? false
                                    : true
                                }
                                className={
                                  expenseDetail?.empID === decryptedEmpID &&
                                  expenseDetail?.status ===
                                    process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                                    ? "rounded-md"
                                    : "select-isDisabled rounded-md"
                                }
                                placeholder="Select Expense Code"
                                defaultValue={expenseCodes.find(
                                  (obj) =>
                                    obj.value === detail?.expenseCodeID?._id,
                                )}
                                onChange={(value) => {
                                  handleChange(index, "expenseCodeID", value);
                                  const tempErrors = [
                                    ...errorMsg.expensesDetails,
                                  ];
                                  tempErrors[index] = {
                                    ...tempErrors[index],
                                    expenseCodeID: value?.value
                                      ? ""
                                      : "Expense Code is Mandatory",
                                  };
                                  setErrorMsg({
                                    ...errorMsg,
                                    expensesDetails: tempErrors,
                                  });
                                }}
                                options={expenseCodes}
                              />

                              <small className="text-danger">
                                {errorMsg.expensesDetails[index]?.expenseCodeID}
                              </small>
                            </div>
                          )}
                        </Col>

                        <Col
                          sm={3}
                          id={
                            expenseDetail?.empID === decryptedEmpID &&
                            expenseDetail?.status ===
                              process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                              ? ""
                              : "loe-disb"
                          }
                        >
                          {allCurrencies.length > 0 && (
                            <>
                              {" "}
                              <Select
                                isDisabled={
                                  expenseDetail?.empID === decryptedEmpID &&
                                  expenseDetail?.status ===
                                    process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                                    ? false
                                    : true
                                }
                                className={
                                  expenseDetail?.empID === decryptedEmpID &&
                                  expenseDetail?.status ===
                                    process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                                    ? "rounded-md"
                                    : "select-isDisabled rounded-md"
                                }
                                placeholder={
                                  detail?.currencyID?._id
                                    ? "Select a currency"
                                    : "N/A"
                                }
                                defaultValue={
                                  detail?.currencyID?._id
                                    ? allCurrencies.find(
                                        (obj) =>
                                          obj.value ===
                                          String(detail?.currencyID?._id),
                                      )
                                    : "N/A"
                                }
                                onChange={(value) => {
                                  handleChange(index, "currencyID", value);
                                  const tempErrors = [
                                    ...errorMsg.expensesDetails,
                                  ];
                                  tempErrors[index] = {
                                    ...tempErrors[index],
                                    currencyID: value?.value
                                      ? ""
                                      : "Currency is Mandatory",
                                  };
                                  setErrorMsg({
                                    ...errorMsg,
                                    expensesDetails: tempErrors,
                                  });
                                }}
                                options={allCurrencies}
                              />
                              <small className="text-danger">
                                {errorMsg.expensesDetails[index]?.currencyID}
                              </small>
                            </>
                          )}
                        </Col>

                        <Col
                          sm={3}
                          id={
                            expenseDetail?.empID === decryptedEmpID &&
                            expenseDetail?.status ===
                              process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                              ? ""
                              : "loe-disb"
                          }
                        >
                          <input
                            disabled={
                              expenseDetail?.empID === decryptedEmpID &&
                              expenseDetail?.status ===
                                process.env.REACT_APP_SENTBACK_STATUS.toUpperCase()
                                ? false
                                : true
                            }
                            placeholder="Cost"
                            className="form-control rounded-md"
                            defaultValue={detail?.cost}
                            onChange={(e) => {
                              const value = e.target.value;
                              handleChange(index, "cost", value);

                              // Regular expression to allow only numbers and decimals
                              const regex = /^[0-9]*\.?[0-9]*$/;

                              // Update the cost field only if it matches the regex
                              if (regex.test(value) || value === "") {
                                const tempErrors = [
                                  ...errorMsg.expensesDetails,
                                ];

                                tempErrors[index] = {
                                  ...tempErrors[index],

                                  cost: value ? "" : "Cost is Mandatory",
                                };

                                setErrorMsg({
                                  ...errorMsg,
                                  expensesDetails: tempErrors,
                                });
                              } else {
                                // Set error message if invalid input

                                const tempErrors = [
                                  ...errorMsg.expensesDetails,
                                ];

                                tempErrors[index] = {
                                  ...tempErrors[index],

                                  cost: "Only numbers and decimals are allowed",
                                };

                                setErrorMsg({
                                  ...errorMsg,

                                  expensesDetails: tempErrors,
                                });
                              }
                            }}
                          />

                          <small className="text-danger">
                            {errorMsg?.expensesDetails[index]?.cost}
                          </small>
                        </Col>

                        <Col sm={2}>
                          {detail?.mediaInfo.length > 0 &&
                            mediaItem?.["item_" + index] === undefined &&
                            detail?.mediaInfo.map((file, indx) => (
                              <div
                                className="symbol symbol-100 symbol-light mr-3 h-65 float-left border border-light-dark"
                                key={indx}
                              >
                                {expenseDetail?.empID === decryptedEmpID &&
                                  expenseDetail?.status ===
                                    process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() && (
                                    <i
                                      className="ki ki-close upload_close"
                                      onClick={() =>
                                        handleMediaRemove(detail, index)
                                      }
                                    ></i>
                                  )}

                                {file?.savedFileType === "jpeg" ||
                                file?.savedFileType === "jpg" ||
                                file?.savedFileType === "png" ? (
                                  <SlideshowLightbox>
                                    <img
                                      className="rounded"
                                      src={`${process.env.REACT_APP_BACKEND}/${file?.savedFilepath}`}
                                      alt="media"
                                      width="100"
                                      height="100"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleImageClick(
                                          `${process.env.REACT_APP_BACKEND}/${file?.savedFilepath}`,
                                        )
                                      }
                                    />
                                  </SlideshowLightbox>
                                ) : (
                                  <div className="align-items-center d-flex h-65px justify-content-center w-65px">
                                    <a
                                      href={`${process.env.REACT_APP_BACKEND}/${file?.savedFilepath}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <i className="flaticon-file-2 uploadIcons"></i>
                                    </a>
                                  </div>
                                )}
                              </div>
                            ))}
                          {expenseDetail?.empID === decryptedEmpID &&
                            expenseDetail?.status ===
                              process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() && (
                              <div>
                                {(mediaItem?.["item_" + index] === "removed" ||
                                  mediaItem?.["item_" + index] ===
                                    "freshUpload" ||
                                  detail?.mediaInfo?.length === 0) && (
                                  <div className="symbol symbol-100 symbol-light mr-3 h-65 float-left">
                                    <input
                                      id={`fileInput${index}`}
                                      type="file"
                                      accept=".png, .jpg, .jpeg, .pdf, .docx, .doc"
                                      onChange={(event) =>
                                        handleFileChange(index, event)
                                      }
                                      style={{ display: "none" }}
                                    />
                                    <Button
                                      type="primary"
                                      onClick={() =>
                                        document
                                          .getElementById(`fileInput${index}`)
                                          .click()
                                      }
                                      className="redbutton d-block"
                                    >
                                      Upload
                                    </Button>
                                    {/* Typography section that synchronizes with mediaInfo */}
                                    {detail?.mediaInfo &&
                                    detail?.mediaInfo.length > 0 ? (
                                      <Typography.Text>
                                        {detail?.mediaInfo.length} file(s)
                                        attached
                                      </Typography.Text>
                                    ) : (
                                      <Typography.Text>
                                        Only one file can be uploaded. Allowed
                                        file types: .jpg, .png, max size: 4MB.
                                      </Typography.Text>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                        </Col>
                      </Row>
                    );
                  })}
              </div>
              {/*Repeater Area*/}
              <Row gutter={[24, 24]}>
                <Col sm={12}>
                  {/* Card for Approvers */}
                  <Card
                    title="Approvers Status"
                    bordered={true}
                    style={{ marginBottom: "10px" }}
                  >
                    {expenseDetail?.approvers && (
                      <List
                        itemLayout="horizontal"
                        dataSource={expenseDetail?.approvers}
                        renderItem={(approver, index) => (
                          <List.Item>
                            <List.Item.Meta
                              title={
                                <>
                                  <Tooltip
                                    title={`Approver ${index + 1}: ${
                                      approver?.additional?.name
                                    }`}
                                  >
                                    <span>
                                      <strong>Approver Name: </strong>
                                      {approver?.additional?.name}
                                    </span>
                                  </Tooltip>
                                </>
                              }
                              description={getStatusBadge(
                                approver?.status,
                                approver?.reason,
                              )}
                            />
                          </List.Item>
                        )}
                      />
                    )}
                  </Card>
                </Col>

                <Col sm={12}>
                  {/* Card for Admin Actions */}
                  <Card title="Admin Action Status" bordered={true}>
                    {expenseDetail?.adminApprover &&
                    expenseDetail?.adminApprover.length > 0 ? (
                      <List
                        itemLayout="horizontal"
                        dataSource={expenseDetail?.adminApprover}
                        renderItem={(adminApprover, index) => (
                          <List.Item>
                            <List.Item.Meta
                              title={
                                <>
                                  <Tooltip
                                    title={`Approver: ${adminApprover?.userID?.name}`}
                                  >
                                    <span>
                                      <strong>Approver Name: </strong>
                                      {adminApprover?.userID?.name}
                                    </span>
                                  </Tooltip>
                                </>
                              }
                              description={getStatusBadge(
                                adminApprover?.status,
                                adminApprover?.reason,
                              )}
                            />
                          </List.Item>
                        )}
                      />
                    ) : (
                      <div className="admin-status-awaiting">
                        <span>
                          Admin action will take place after all approvers
                          complete their approvals.
                        </span>
                      </div>
                    )}
                  </Card>
                </Col>
                {expenseDetail?.seekAcknowledgment?.[0]?.ackMessage !==
                  null && (
                  <Col sm={24}>
                    <Card
                      title="Acknowledgement Received"
                      bordered={true}
                      className="mb-10"
                    >
                      {expenseDetail?.seekAcknowledgment?.[0]?.ackMessage}
                    </Card>
                  </Col>
                )}

                {/* {expenseDetail?.onBehalfApprovers && (
                  <Col sm={24}>
                    <Card
                      title="Approved by Admin on behalf of following approvers:"
                      bordered={true}
                      className="mb-10"
                    >
                      {expenseDetail?.onBehalfApprovers}
                    </Card>
                  </Col>
                )} */}

                {expenseDetail?.history[expenseDetail?.history.length - 1]
                  .status ===
                  process.env.REACT_APP_SEEK_ACK_STATUS.toUpperCase().replace(
                    " ",
                    "",
                  ) &&
                expenseDetail?.seekAcknowledgment?.[0]?.ackMessage === null &&
                expenseDetail?.seekAcknowledgment?.[0]?.sentAt !== null &&
                storeAcknowledgement !== false ? (
                  <Col sm={24}>
                    <Card
                      title="Seek Acknowledgement"
                      bordered={true}
                      className="mb-10"
                    >
                      <span>Request Sent</span>
                    </Card>
                  </Col>
                ) : (
                  storeRole === process.env.REACT_APP_AROLE &&
                  storeAcknowledgement === false &&
                  expenseDetail?.seekAcknowledgment?.[0]?.sentAt !== null &&
                  expenseDetail?.seekAcknowledgment?.[0]?.ackMessage === null &&
                  expenseDetail?.history[expenseDetail?.history.length - 1]
                    .status ===
                    process.env.REACT_APP_SEEK_ACK_STATUS.toUpperCase().replace(
                      " ",
                      "",
                    ) && (
                    <Col sm={24}>
                      <Card
                        title={
                          expenseDetail?.seekAcknowledgment[0]?.ackMessage !==
                          null
                            ? "Acknowledgement Received"
                            : "Seek Acknowledgement"
                        }
                        bordered={true}
                        className="mb-10"
                      >
                        <div className="admin-status-awaiting">
                          <textarea
                            name="ackMessage"
                            className="form-control h-100px"
                            onChange={(e) => {
                              setExpenseDetail({
                                ...expenseDetail,
                                ackMessage: e?.target?.value
                                  ? e?.target?.value
                                  : "",
                              });
                            }}
                          />
                        </div>
                      </Card>
                    </Col>
                  )
                )}
              </Row>
              {storeRole === process.env.REACT_APP_ADROLE &&
                expenseDetail?.adminApprover?.[0]?.status ===
                  process.env.REACT_APP_APPROVED_STATUS.toUpperCase() &&
                expenseDetail?.paymentPaidOn === null && (
                  <>
                    <div className="mt-5">
                      <Row gutter={[24, 24]}>
                        <Col sm={12}>
                          <label className="font-weight-bolder font-size-lg">
                            <input
                              type="checkbox"
                              defaultValue={true}
                              onChange={(e) => {
                                setPaymentStatus(e.target.checked);

                                if (e.target.checked === false) {
                                  setErrorMsg({
                                    ...errorMsg,
                                    paymentStatus:
                                      "Payment Status is Mandatory",
                                  });
                                } else {
                                  const updatedErrorMsg = { ...errorMsg };
                                  delete updatedErrorMsg.paymentStatus;
                                  delete updatedErrorMsg.paymentPaidOn;
                                  setErrorMsg(updatedErrorMsg);
                                }
                              }}
                            />
                            <span className="ml-2">
                              Confirm Payment Status as Paid
                            </span>
                            <br />
                            <small className="text-danger">
                              {errorMsg.paymentStatus}
                            </small>
                          </label>
                        </Col>
                      </Row>
                      {paymentStatus === true && (
                        <div className="mt-5">
                          <Row gutter={[24, 24]}>
                            <Col sm={12}>
                              <label className="font-weight-bolder font-size-lg">
                                <label className="mb-3">
                                  <strong>Payment Paid On</strong>
                                </label>

                                <DatePicker
                                  // disabledDate={
                                  //   disableFutureDatesForPaymentPaidOn
                                  // }
                                  format="DD-MM-YYYY"
                                  placeholder="Select Date"
                                  className="form-control rounded-md"
                                  allowClear={true}
                                  defaultValue={[
                                    expenseDetail?.paymentPaidOn
                                      ? dayjs(
                                          expenseDetail?.paymentPaidOn,
                                          "YYYY-MM-DD",
                                        )
                                      : null,
                                  ]}
                                  onChange={(date, dateString) => {
                                    const formattedDate = moment(
                                      dateString,
                                      "DD-MM-YYYY",
                                    ).format("YYYY-MM-DD");
                                    setPaymentStatus(true);
                                    if (formattedDate) {
                                      setPaymentPaidOn(formattedDate);
                                    }

                                    if (date === "") {
                                      setErrorMsg({
                                        ...errorMsg,
                                        paymentPaidOn:
                                          "Payment Paid On date is Mandatory",
                                      });
                                    } else {
                                      const updatedErrorMsg = { ...errorMsg };
                                      delete updatedErrorMsg.paymentPaidOn;
                                      setErrorMsg(updatedErrorMsg);
                                    }
                                  }}
                                />

                                <small className="text-danger">
                                  {errorMsg.paymentPaidOn}
                                </small>
                              </label>
                            </Col>
                            <Col sm={12}>
                              <label className="font-weight-bolder font-size-lg">
                                <label className="mb-3">
                                  <strong>Mode of Payment</strong>
                                </label>
                                <Radio.Group
                                  onChange={handleMainChange}
                                  value={mainSelectionForModeOfPayment}
                                  style={{ width: "100%" }}
                                >
                                  <Row>
                                    <Col span={24}>
                                      <Radio value="HDFC Bank">HDFC Bank</Radio>
                                    </Col>
                                    <Col span={24}>
                                      <Radio value="9071 GPAY">9071 GPAY</Radio>
                                    </Col>
                                    <Col span={24}>
                                      <Radio value="Credit Card">
                                        Credit Card
                                      </Radio>
                                    </Col>
                                    <Col span={24}>
                                      <Radio value="6449 Personal">
                                        6449 Personal
                                      </Radio>
                                    </Col>
                                  </Row>
                                </Radio.Group>
                                {mainSelectionForModeOfPayment ===
                                  "Credit Card" && (
                                  <div
                                    style={{ paddingLeft: 24, marginTop: 12 }}
                                  >
                                    <Radio.Group
                                      onChange={handleCreditCardOptionChange}
                                      value={creditCardOption}
                                    >
                                      <Radio value="1421 Corporate">
                                        1421 Corporate
                                      </Radio>
                                      <br />
                                      <Radio value="2463 Corporate">
                                        2463 Corporate
                                      </Radio>
                                      <br />
                                      <Radio value="411009 Amex">
                                        41009 Amex
                                      </Radio>
                                    </Radio.Group>
                                  </div>
                                )}
                                <small className="text-danger">
                                  {errorMsg.modeOfPayment}
                                </small>
                              </label>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </div>
                  </>
                )}
              {expenseDetail?.paymentPaidOn !== null && (
                <p className="expenseStatusApproved statusmesg">
                  Payment Paid On :{" "}
                  <strong>
                    {moment(expenseDetail?.paymentPaidOn).format(
                      "Do MMM, YYYY",
                    )}
                  </strong>
                </p>
              )}
              {expenseDetail?.modeOfPayment && (
                <p className="expenseStatusApproved statusmesg">
                  Mode of Payment:{" "}
                  <strong>{expenseDetail?.modeOfPayment}</strong>
                </p>
              )}
              <Row>
                <Col xs={24}>
                  <p className="font-size-h5 font-weight-boldest m-0 ml-auto text-uppercase text-right">
                    Total Reimbursement: {totalReimbursement}
                  </p>
                </Col>
              </Row>
              {shouldShowResubmitButton && (
                <>
                  <div className="text-right mt-5">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className=" btn font-size-h5 font-weight-bold mx-auto px-5 py-2 redbutton rounded-lg text-white"
                    >
                      Resubmit
                    </Button>
                  </div>
                </>
              )}
              {shouldShowUpdateButton && (
                <div className="text-right mt-5">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className=" btn font-size-h5 font-weight-bold mx-auto px-5 py-2 redbutton rounded-lg text-white"
                  >
                    Update
                  </Button>
                </div>
              )}
              {expenseDetail?.status ===
                process.env.REACT_APP_DRAFT_STATUS.toUpperCase() && (
                <div className="text-right mt-5">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className=" btn font-size-h5 font-weight-bold mx-auto px-5 py-2 redbutton rounded-lg text-white"
                  >
                    Submit
                  </Button>
                </div>
              )}

              <Modal
                title="Confirm Expense"
                open={isModalVisible}
                onCancel={handleCancel}
                // cancelText="No"
                // okText="Yes"
                footer={[
                  <div className="addExpenseConfirmationModalFooter">
                    <Button
                      key="submit"
                      className="okSbmit submit-btn border-0 rounded"
                      onClick={handleOk}
                    >
                      Yes
                    </Button>
                    <div className={`loader`}></div>
                  </div>,
                  <Button
                    key="back"
                    className="cancelSbmit submit-btn border-0 rounded"
                    onClick={handleCancel}
                  >
                    No
                  </Button>,
                ]}
              >
                {(expenseDetail?.isNoResponse === true &&
                  expenseDetail?.history[expenseDetail?.history.length - 1]
                    ?.status ===
                    process.env.REACT_APP_RESENT_AFTER_NORESPONSE) ||
                (paymentStatus === true && paymentPaidOn !== null) ? (
                  <p>
                    Please review your selected or entered information carefully
                    before updating the form, as changes may not be possible
                    once it's updated.
                  </p>
                ) : (
                  <p>
                    Please review your selected or entered information carefully
                    before resubmitting the form, as changes may not be possible
                    once it's resubmitted.
                  </p>
                )}
              </Modal>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
